module.exports = __webpack_public_path__ + "img/akazoeffnungszeiten.dec7aeb1.png";